
const layout = () => import('./components/ui/layout')

const Account = () => import('./pages/Account')
const LenderResults = () => import('./pages/LenderResults')
const MatchResult = () => import('./pages/MatchResult')

export default [
  {
    path: '/user',
    component: layout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'account-settings',
        name: 'AccountSettings',
        component: Account,
        alias: ['/account-settings'],
        meta: {
          title: 'Account Settings',
        },
      },
      {
        path: 'lender-results',
        name: 'LenderResults',
        component: LenderResults,
        alias: ['/lender-results'],
        meta: {
          title: 'Lender Results',
        },
      },
    ],
  },
  {
    path: '/matches',
    component: layout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: ':dealId',
        name: 'Matches',
        component: MatchResult,
        props: true,
        meta: {
          title: 'Matches',
        },
      },
    ],
  },
]
